module.exports = __webpack_public_path__ + "7b9ac5e4f69605e3d93477d9887fa37f.jpg";